import ThemeProvider from "./theme"
import { AnimatePresence } from "framer-motion"
import { Switch, Route } from "react-router"
import { BrowserRouter } from "react-router-dom"
import { createBrowserHistory } from "history"
import { I18nextProvider } from "react-i18next"
import Landing from "./screens/Landing"
import i18n from "./i18n/i18n-config"
import DependencyProvider from "./components/DependencyProvider"
import { primaryRoutes } from "./routes"
import dependencies from "./dependencies"
import NavigationMenu from "./components/NavigationMenu"
import RouteBroadcaster from "./components/RouteBroadcaster"
import { useEffect } from "react"
import { useStore } from "./state/store"
import ShareApartments from "./screens/ShareApartments"
import Broadcasters from "./state/Broadcasters"
import LightsBroadcaster from "./components/LightsBroadcaster"
import ApartmentFinder from "./components/ApartmentFinder"
const history = createBrowserHistory()

const basename = "/"

export const ApartmentSheetURL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSWIphFZPj9D0-MmtMzNtPgVbzT7Mx00bjEgOT2Q0mhR17QTaQx4ZveVh97hnQrVxtY02Ya2Pp_rzFy/pub?output=csv"
// export const ApartmentSheetURL =
//   "https://docs.google.com/spreadsheets/d/e/2PACX-1vSWIphFZPj9D0-MmtMzNtPgVbzT7Mx00bjEgOT2Q0mhR17QTaQx4ZveVh97hnQrVxtY02Ya2Pp_rzFy/pub?gid=87002499&single=true&output=csv"

function App() {
  const setApartments = useStore(state => state.setApartments)
  const isShare = useStore(state => state.isShare)
  const loaded = useStore(state => state.loaded)
  useEffect(() => {
    fetch(ApartmentSheetURL)
      .then(response => {
        response.text().then(text => {
          const data = text.split("\r\n").map(line => line.split(","))
          const header = data[1]
          const apartmentsLines = data.slice(2)
          const apartments = []
          for (let line of apartmentsLines) {
            const apartment = {}
            for (let x = 0; x < line.length; x++) {
              apartment[header[x]] = line[x]
            }
            apartments.push(apartment)
          }
          // apartments.map(ap => (ap.Status = "0"))
          console.log(apartments)
          setApartments(apartments)
          // localStorage.setItem("apartments", JSON.stringify(apartments))
        })
      })
      .catch(err => {
        console.log("ERRR", err)
        // setApartments(JSON.parse(localStorage.getItem("apartments")))
      })
  }, [])

  return (
    <ThemeProvider>
      <DependencyProvider dependencies={dependencies}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter history={history} basename={basename}>
            <AnimatePresence>
              <Switch>
                <Route exact path={basename} component={Landing} />
                {primaryRoutes.map(({ path, component }) => (
                  <Route key={path} path={path} component={component} />
                ))}
                <Route path={"/share_apartments"} component={ShareApartments} />
              </Switch>
            </AnimatePresence>
            {process.env.REACT_APP_MARKETING_SUITE && <RouteBroadcaster />}
            {process.env.REACT_APP_MARKETING_SUITE && <Broadcasters />}
            {process.env.REACT_APP_ROLE === "sender" && <LightsBroadcaster />}
            {!isShare && (
              <>
                {loaded && <NavigationMenu routes={primaryRoutes} />}
                <ApartmentFinder />
              </>
            )}
          </BrowserRouter>
        </I18nextProvider>
      </DependencyProvider>
    </ThemeProvider>
  )
}

export default App
